import React, { useMemo } from 'react';
import Select from 'react-select';
import { dropdownTemplate } from '../../../theme';
import { EMPTY_FILTERS, FILTER_FIELDS, TENORS } from '../../../utils/straddleMappings';

const TENOR_ORDER = TENORS.map((t) => t.key);
const QUALITY_ORDER = ['Good', 'Fair', 'Poor'];

const SORTERS = {
  callTenors: (a, b) => TENOR_ORDER.indexOf(a) - TENOR_ORDER.indexOf(b),
  putTenors: (a, b) => TENOR_ORDER.indexOf(a) - TENOR_ORDER.indexOf(b),
  qualities: (a, b) => QUALITY_ORDER.indexOf(a) - QUALITY_ORDER.indexOf(b),
};

/**
 * Multi-select filters for straddle results.
 *
 * Options come from the current result set rather than the full preset lists, so
 * a filter never offers a value that would empty the table.
 */
function StraddleFilterControls({ results, filters, onChange }) {
  const options = useMemo(() => Object.fromEntries(FILTER_FIELDS.map(({ key, field }) => {
    const values = Array.from(new Set((results || []).map((row) => row[field]).filter(Boolean)));
    values.sort(SORTERS[key] || ((a, b) => a.localeCompare(b)));
    return [key, values.map((value) => ({ value, label: value }))];
  })), [results]);

  const hasFilters = FILTER_FIELDS.some(({ key }) => (filters?.[key] || []).length > 0);

  if (!results || results.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-3 items-end mb-4">
      {FILTER_FIELDS.filter(({ key }) => options[key].length > 0).map(({ key, label }) => (
        <div key={key} style={{ minWidth: 150, maxWidth: 240, flex: '1 1 150px' }}>
          <label className="block text-xs text-gray-400 mb-1">{label}</label>
          <Select
            isMulti
            aria-label={`Filter by ${label}`}
            options={options[key]}
            value={(filters?.[key] || []).map((value) => ({ value, label: value }))}
            onChange={(selected) => onChange({ ...filters, [key]: (selected || []).map((s) => s.value) })}
            placeholder="All"
            styles={dropdownTemplate.reactSelectStyles}
          />
        </div>
      ))}
      {hasFilters && (
        <button
          type="button"
          onClick={() => onChange(EMPTY_FILTERS)}
          className="text-sm py-2 px-3 rounded border bg-[#1f2937] text-[#b0b0b0] border-[#333] hover:bg-[#218aff]/10 hover:text-[#218aff] hover:border-[#218aff] transition-all"
        >
          Clear filters
        </button>
      )}
    </div>
  );
}

export default StraddleFilterControls;
